import moment, { Moment } from "moment";

export interface MemoDto {
  eventCheckInMemoId: number;
  createdAt: string;
  createdBy: string;
  body: string;
}

export class Memo {
  id: number;
  createdAt: Moment;
  createdBy: string;
  body: string;

  constructor(dto: MemoDto) {
    this.id = dto.eventCheckInMemoId;
    this.createdAt = moment(dto.createdAt);
    this.createdBy = dto.createdBy;
    this.body = dto.body;
  }
}
